import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=8ef5989c&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef5989c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef5989c')) {
      api.createRecord('8ef5989c', component.options)
    } else {
      api.reload('8ef5989c', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=8ef5989c&scoped=true&", function () {
      api.rerender('8ef5989c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/plugins/Loading.vue"
export default component.exports